// @flow
import * as React from 'react';
import { graphql, compose } from 'react-apollo';

import CREATE_ORGANIZATION_UNAUTHED_MUTATION from 'organizations/queries/CreateOrganizationUnauthedMutation.gql';
import type {
  createOrganizationUnauthed,
  CreateOrganizationUnauthedInput,
} from 'organizations/queries/__generated__/createOrganizationUnauthed';

type Props = {
  children: Function,
  createOrgWhileUnauthed: (
    data: CreateOrganizationUnauthedInput
  ) => Promise<{ data: createOrganizationUnauthed }>,
};

class OrganizationCreateContainer extends React.Component<Props, void> {
  render() {
    return this.props.children({
      createOrgWhileUnauthed: this.props.createOrgWhileUnauthed,
    });
  }
}

const withUnauthedMutation = graphql(CREATE_ORGANIZATION_UNAUTHED_MUTATION, {
  props: ({ mutate }) => ({
    createOrgWhileUnauthed: (input: CreateOrganizationUnauthedInput) => {
      return mutate({
        variables: { input },
      });
    },
  }),
});

export { OrganizationCreateContainer };

export default compose(withUnauthedMutation)(OrganizationCreateContainer);
